export function getRegisterURLC2B(lang){
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/payments/register-ipn-url/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'ConfirmationUrl' => '{{REPLACE_YOUR_CALLBACK_HERE}}'
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    const python=`
        
merchant_code = "your_merchant_code"
url = 'https://sandbox.sasapay.app/api/v1/payments/register-ipn-url/'
payload = {
    "MerchantCode": 'your_merchant_code',
    "ConfirmationUrl": "yourdomain",
}
headers = {
        'Authorization': f'Bearer "your_access_token" ' 
        }
try:
    res = requests.post(url, headers=headers,data=payload)
    response = json.loads(res.text)
    
    print(response)
except Exception as error:
    print(str(error))
    `
    const java=`
        public  static  void  registerCallbackUrl (){

       String access_token = "generated access token";

       String api_endpoint = "Endpoint";
       
    try {
        URL url = new URL(api_endpoint);
        HttpURLConnection connection = (HttpURLConnection) url.openConnection();
        connection.setRequestMethod("POST");
        connection.setDoOutput(true);

        String data = "MerchantCode=merchant_code&ConfirmationUrl=confirmation_url";
        byte[] dataBytes = data.getBytes(StandardCharsets.UTF_8);

        connection.setRequestProperty("Content-Type", "application/x-www-form-urlencoded");
        connection.setRequestProperty("Authorization", "Bearer "+access_token);
        connection.setRequestProperty("Content-Length", Integer.toString(dataBytes.length));

        try (DataOutputStream outputStream = new DataOutputStream(connection.getOutputStream())) {
            outputStream.write(dataBytes);
        }

        int responseCode = connection.getResponseCode();
        if (responseCode == HttpURLConnection.HTTP_OK) {
            StringBuilder response = new StringBuilder();
            try (Scanner scanner = new Scanner(new InputStreamReader(connection.getInputStream()))) {
                while (scanner.hasNextLine()) {
                    response.append(scanner.nextLine());
                }
            }
            JSONObject jsonResponse  = new JSONObject(response.toString());
            System.out.println(jsonResponse);


        } else {
            System.out.println("Response code: " + responseCode);
        }
    } catch (Exception e) {
        e.printStackTrace();
    }

}
    `
    if (lang==='java') {
        return java
    } else if (lang==='php') {
        return laravel
    } else {
        return python
    }
}
export function getC2BCallbackResponse(){
    return `
       {
          "statusCode": "0",
          "detail": "Confirmation URL registered successfully"
       }
    `
}